// enum value will be used to perform screen width size check for responsive design.
export enum Resolutions {
  Mobile = 320,
  Tablet = 753,
  Desktop = 1180,
  MobileLandscape = 568,
}
